import * as types from './constants';

const initialState = {
  data: {},
  getLoading: false,
  updateLoading: false,
  errors_api: {}
};

const actions = {
  // Get Group
  [types.GET_GROUP_REQUEST]: state => {
    const data = {
      ...state,
      getLoading: true
    };

    return { ...data };
  },

  [types.GET_GROUP_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      data: payload,
      getLoading: false
    };

    return { ...data };
  },

  [types.GET_GROUP_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      getLoading: false,
      errors_api: payload
    };

    return { ...data };
  },

  // Update Group
  [types.UPDATE_GROUP_REQUEST]: state => {
    const data = {
      ...state,
      updateLoading: true
    };

    return { ...data };
  },

  [types.UPDATE_GROUP_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      updateLoading: false,
      data: payload
    };

    return { ...data };
  },

  [types.UPDATE_GROUP_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      updateLoading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.UPDATE_GROUP_RESET]: () => {
    const data = {
      ...initialState
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

